import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const ArrowLeft = (props) => {
  const { height, width, fill, stroke, className } = props;
  return (
    <svg
      id="arrow-left"
      width={width}
      height={height}
      fill={fill}
      stroke={stroke}
      className={className}
      viewBox="0 0 15 25"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M0.53968 13.7376L11.8543 24.4869C12.5741 25.171 13.741 25.171 14.4604 24.4869C15.1799 23.8034 15.1799 22.6948 14.4604 22.0113L4.4487 12.4998L14.4601 2.98869C15.1796 2.30489 15.1796 1.19638 14.4601 0.512853C13.7407 -0.170951 12.5738 -0.170951 11.854 0.512853L0.53939 11.2623C0.179661 11.6042 0 12.0519 0 12.4998C0 12.9479 0.180011 13.3959 0.53968 13.7376Z" />
    </svg>
  );
};
/* eslint-enable max-len */

ArrowLeft.defaultProps = {
  className: null,
};

ArrowLeft.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  stroke: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default ArrowLeft;
